// Stripe's v9 ("Clover") change stopped the deferred-mode PaymentElement from auto-collecting the
// postal code for these countries; every other country is unaffected. On the surfaces that use the
// deferred PaymentElement (PaymentElementsForm, Sisu/PaymentMethod) we render our own labelled
// postal input for these countries and inject it into `billing_details.address.postal_code` when
// creating the PaymentMethod — otherwise the backend's tax verification rejects with
// `stripe_invalid_tax_location`.
//
// Single source of truth shared by both surfaces so the set can't drift (the drift is exactly why
// Sisu/PaymentMethod originally missed this fix). Stripe ISO codes: GB = United Kingdom, PR =
// Puerto Rico.
export const CUSTOM_POSTAL_COUNTRIES = new Set(['CA', 'GB', 'PR']);

/** Whether the given billing country needs the custom postal field (Clover gap-fill). */
export const requiresCustomPostal = (country: string | null | undefined): boolean =>
	!!country && CUSTOM_POSTAL_COUNTRIES.has(country.toUpperCase());

/**
 * Whether to label the field "ZIP code" (Puerto Rico) vs "Postal code" (CA/UK) — matches Stripe's
 * own copy. Each surface maps this to its own localized message descriptor.
 */
export const usesZipCodeLabel = (country: string | null | undefined): boolean =>
	country?.toUpperCase() === 'PR';
